import DOMPurify from "dompurify";

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName !== "A") {
    return;
  }

  const target = node.getAttribute("target");
  if (!target || target.toLowerCase() !== "_blank") {
    return;
  }

  const rel = new Set(
    (node.getAttribute("rel") || "").split(/\s+/).filter(Boolean),
  );
  rel.add("noopener");
  rel.add("noreferrer");
  node.setAttribute("rel", [...rel].join(" "));
});
